import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import QmsImplementationRemediation, { QMS_META_TITLE, QMS_META_DESCRIPTION, QMS_HERO_IMAGE } from "@/pages/QmsImplementationRemediation";

export const Route = createFileRoute("/en/services/quality-assurance/qms-development-optimization")({
  head: () =>
    buildRouteHead("/en/services/quality-assurance/qms-development-optimization", {
      title: QMS_META_TITLE,
      description: QMS_META_DESCRIPTION,
      ogImage: QMS_HERO_IMAGE,
    }),
  component: QmsImplementationRemediation,
});
